module.exports = __webpack_public_path__ + "img/male11.23931ff1.jpeg";